import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Prediction} from './prediction';
import {ApiService} from '../../core/services/api.service';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PredictionService {
  url = 'upload.php';

  constructor(private apiService: ApiService) {
  }

  upload(blob: Blob): Observable<Prediction> {
    const formData = new FormData();
    formData.append('file', blob);

    return this.apiService.upload<Prediction>(this.url, formData)
      .pipe(map(res => new Prediction(res)));
  }
}
